export class TvSymbolInfoPriceSource {
}
